// import request from '@/utils/requests'
import axios from './http'

export function setAccountInfo(accountInfo, token) {
  return axios({
    url: '/api/core_admin/setAccountInfo',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: accountInfo
  })
}

export function getAccountInfo(token) {
  return axios({
    url: '/api/core_admin/getAccountInfo',
    method: 'post',
    headers: {
      'authorization': token
    },
  })
}

export function coreAdmin(token, dataParam) {
  return axios({
    url: '/api/core_admin/getAllData',
    headers: {
      'authorization': token
    },
    method: 'POST',
    data: dataParam
  })
}

export function setDataManager(token, dataManagement, id) {
  return axios({
    url: '/api/core_admin/setDataManager',
    headers: {
      'authorization': token,
      'id': id
    },
    method: 'post',
    data: dataManagement
  })
}

export function setRuleConfiguration(token, configuration, id) {
  return axios({
    url: '/api/core_admin/setRuleConfiguration',
    headers: {
      'authorization': token,
      'id': id
    },
    method: 'post',
    data: configuration
  })
}

export function setFundsConfiguration(token, ruleConfiguration, id) {
  return axios({
    url: '/api/core_admin/setFundsConfiguration',
    headers: {
      'authorization': token,
      'id': id
    },
    method: 'post',
    data: ruleConfiguration
  })
}

export function setProcessReview(token, processReview, id) {
  return axios({
    url: '/api/core_admin/setProcessReview',
    headers: {
      'authorization': token,
      'id': id
    },
    method: 'post',
    data: processReview
  })
}

export function uploadLogo(token, formData, supplierId) {
  return axios({
    url: '/api/core_admin/uploadLogo/' + supplierId,
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}

export function reportExcel(token,supplierId) {
  return axios({
    url: '/api/core_admin/reportExcel/' + supplierId,
    headers: {
      'authorization': token,
    },
    method: 'get',
    responseType: 'blob'

  })
}

export function putExcel(token,supplierId,params) {
  return axios({
    url: '/api/core_admin/putExcel',
    headers: {
      'authorization': token,
      'supplierId' : supplierId,
      'Content-Type':'multipart/form-data'
    },
    method: 'post',
    data: params
  })
}



